export const MODAL = {
  TITLE: 'Delete Tracking Setting',
  DESCRIPTION: 'This tracking setting is about to be permanently deleted and you won\'t be able to restore it.',
  WARNING: 'Warning: You can\'t undo this action.',
  BUTTONS: {
    CANCEL: 'Cancel',
    DELETE: 'Delete',
  },
};
